import React from "react";
import { Tooltip } from "react-tooltip";
import { ReactComponent as Info } from "src/assets/icons/icon-info.svg";
import "./icon-tooltip.scss";

export enum IconTooltipType {
  INFO = "info",
}

interface IconTooltipProps {
  iconType: IconTooltipType;
  className?: string;
  tooltipContent?: string;
  tooltipHtml?: string;
  tooltipId?: string;
}

const IconTooltip: React.FC<IconTooltipProps> = ({
  iconType,
  className,
  tooltipContent,
  tooltipHtml,
  tooltipId,
}): JSX.Element => {
  const icons = {
    [IconTooltipType.INFO]: Info,
  };

  const Icon = icons[iconType];

  return (
    <>
      <Icon
        className={`icon-tooltip ${className}`}
        data-tooltip-id={tooltipId}
        data-tooltip-content={tooltipContent}
        data-tooltip-html={tooltipHtml}
      />

      <Tooltip id={tooltipId} place="bottom" />
    </>
  );
};

export default IconTooltip;
